export default {
	title: "Save your goal before creating KRs.",
	description: "Define and save your goal first, then return here to create the measurable steps for accomplishing that goal.",
};
